
import React, { useEffect, useState, FunctionComponent, useRef, ReactNode, useMemo } from "react";

interface AnimatedSectionProps {
  animationClass: string;
  children: ReactNode; // 添加 children 属性
  className?: string
}
export const AnimatedSection: FunctionComponent<AnimatedSectionProps> = ({ animationClass, children, className='' }) => {
  const [hasAnimated, setHasAnimated] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true); // 当元素进入视口时，设置动画状态为 true
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [hasAnimated]);

  // 根据 hasAnimated 状态动态添加类名以触发动画
  const animationClasses = hasAnimated ? ` ${animationClass}` : "";

  return (
    <div ref={ref} className={`animate__animated ${animationClasses} ${className}`}>
      {children}
    </div>
  );
};